import React from 'react';
import { images } from '../data/site';
type LogoProps = {
  className?: string;
  /** Inverts the black artwork to white for use on dark backgrounds. */
  invert?: boolean;
};
export function Logo({
  className = 'h-12 w-auto',
  invert = false
}: LogoProps) {
  return <img src={images.logo} alt="Triple D Welding & Fabrication" className={`object-contain ${invert ? 'invert' : ''} ${className}`} data-id="element-150" data-mp="3q7qfpja1r8hr" />;
}